import type { ReactNode } from 'react'

/** The top of a member page, as on ernd.io: the title on the dark stage, at most one line under it and one
 *  action beside it. It must be the first thing in a centred page column (it bleeds to the screen edges). */
export function PageBand({ title, sub, action, fine }: { title: ReactNode; sub?: ReactNode; action?: ReactNode; fine?: ReactNode }) {
  return (
    <header className="e-band e-stage e-page-band">
      <div className="e-band-inner">
        <div className="e-page-band-text">
          <h1 className="e-title">{title}</h1>
          {sub ? <p className="e-band-sub">{sub}</p> : null}
          {fine ? <p className="e-band-fine">{fine}</p> : null}
        </div>
        {action ? <div className="e-page-band-action">{action}</div> : null}
      </div>
    </header>
  )
}
